import React from "react";
import prev from "../../../../assets/images/redesign/signup-react/slider/previous.png";
import next from "../../../../assets/images/redesign/signup-react/slider/next.png";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img src={next} alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img src={prev} alt="" />
    </div>
  );
}

const settings = {
  infinite: true,
  speed: 500,
  dots: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  appendDots: dots => (
    <div>
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
  customPaging: i => <div className="pw-custom-paging"></div>,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  variableWidth: true,
  // These work as thresholds from large to small, meaning rules from the large
  // screens will be overridden by rules from the small.
  responsive: [
    {
      breakpoint: 1534,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        variableWidth: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true
      }
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
};

export default settings;
